<template>
  <div
    ref="sizeGuideTooltip"
    role="tooltip"
    class="absolute bottom-6 left-1/2 z-50 mb-2 w-80 -translate-x-1/2 scale-95 bg-white px-3 py-2 text-start text-base text-black drop-shadow-md transition-all duration-300"
    @keydown.esc="close"
  >
    <p class="w-[97%] whitespace-pre-wrap">{{ text }}</p>
    <div
      class="absolute right-[47%] top-full -mt-1 size-2 -translate-x-1/2 rotate-45 bg-white"
    />
    <button
      ref="closeTooltip"
      class="absolute right-1 top-1"
      :aria-label="$t('dialog.close')"
    >
      <IconCloseS
        class="size-7"
        @click="close"
        @keydown.enter="close"
        @blur="close"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from 'vue'
import { onClickOutside, useFocus } from '@vueuse/core'

const { text, ignoreOutsideClickElement } = defineProps<{
  text: string
  ignoreOutsideClickElement: string
}>()

const sizeGuideTooltip = shallowRef()
const closeTooltip = shallowRef()

const emit = defineEmits<{ close: [] }>()

const close = () => emit('close')

useFocus(closeTooltip, { initialValue: true })

onClickOutside(sizeGuideTooltip, close, { ignore: [ignoreOutsideClickElement] })
</script>
